import { useCallback } from 'react';
// import { useDispatch } from 'react-redux';

// import {
// 	evaluateWeightGate,
// 	setPendingWholesaleAdd,
// } from 'helpers/wholesaleWeightGate';
// import { setWholesaleWeightAlert } from 'store/slices/layoutSlice';

const useGuardedAddToCart = () => {
	// const dispatch = useDispatch();

	const guardedAdd = useCallback(async ({ onConfirm }) => {
		// const gate = evaluateWeightGate(item, inCartQty, addQty);
		// if (!gate.show) {
		// 	await onConfirm();
		// 	return;
		// }
		//
		// setPendingWholesaleAdd(onConfirm);
		// dispatch(
		// 	setWholesaleWeightAlert({
		// 		open: true,
		// 		level: gate.level,
		// 		lineKg: gate.lineKg,
		// 		productId: item?.product_id,
		// 		productName: item?.name || item?.product_name || '',
		// 	}),
		// );
		await onConfirm();
	}, []);

	return { guardedAdd };
};

export default useGuardedAddToCart;
